<div [formGroup]="formGroup">
    <label [for]="controlName" class="form-control-label"
        >{{ label }}
        <span class="text-danger">{{ isRequired ? '*' : '' }}</span>
    </label>
    <input
        [id]="controlName"
        type="text"
        class="form-control"
        [formControlName]="controlName"
        [ngbTypeahead]="search"
        (focus)="focus$.next($any($event).target.value)"
        (click)="click$.next($any($event).target.value)"
        (selectItem)="onSelect($event)"
        #instance="ngbTypeahead"
        [ngClass]="{
            'is-invalid':
                formControl.invalid &&
                (formControl.dirty || formControl.touched || changeText)
        }" />
    <div class="invalid-feedback">Campo inválido</div>
</div>
